module.exports = __webpack_public_path__ + "assets/img/DS-master (9).eb370fc6.jpg";